import React, { useState } from "react";
import "./ProductosPopup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ProductosAlerts from "../../ProductosAlerts/ProductosAlerts";
import { ModalCarga } from "../../ModalCarga/ModalCarga";

export const ProductosPopup = ({ isOpen, onClose, alerta, productos, premium, planName, user }) => {
  const [filtro, setFiltro] = useState(""); // 🔍 Estado del buscador

  if (!isOpen) return null;

  const isLoading = productos === undefined;
  const isEmpty = productos?.length === 0;

  // 🔍 Filtro robusto: busca por cualquier palabra en cualquier campo
  const productosFiltrados =
    productos?.filter((producto) => {
      if (!filtro.trim()) return true;
      const texto = filtro.toLowerCase();

      const flattenValues = (obj) => {
        if (obj == null) return "";
        if (typeof obj === "object") {
          try {
            return Object.values(obj)
              .map((v) => flattenValues(v))
              .join(" ");
          } catch {
            return "";
          }
        }
        return String(obj);
      };

      const values = flattenValues(producto).toLowerCase();
      return values.includes(texto);
    }) || [];

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <h2 className="popup-title">{alerta?.data?.tituloAlerta}</h2>

        <div className="popup-body">
          {isLoading ? (
            <ModalCarga inline />
          ) : isEmpty ? (
            <p>No hay productos que coincidan.</p>
          ) : (
            <>
              {/* 🔍 Campo de búsqueda con botón de limpiar */}
              <div className="popup-filtro-productos">
                <div className="filtro-input-wrapper">
                  <input
                    type="text"
                    placeholder="Filtrar productos por cualquier palabra..."
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                  />
                  {filtro && (
                    <button
                      className="clear-filtro-btn"
                      onClick={() => setFiltro("")}
                      title="Borrar filtro"
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}
                </div>
              </div>


              <ul className="products-container-alerts">
                {productosFiltrados.map((producto) => (
                  <li key={producto.id}>
                    <ProductosAlerts
                      key={producto.id}
                      producto={producto}
                      premium={premium}
                      planName={planName}
                      user={user}
                    />
                  </li>
                ))}
              </ul>

              {productosFiltrados.length === 0 && (
                <p style={{ marginTop: "10px" }}>
                  No hay productos que coincidan con el filtro.
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
